import { all } from 'redux-saga/effects';
import { loginFetchWatch, logoutFetchWatch, forgetPasswordFetchWatch } from './login/sagas';
import { getUserFetchWatch, getProviderServiceCodesFetchWatch, updateUserFetchWatch } from './user/sagas';
import { initProviderWatch } from './provider/sagas';
import {
    getNotificationsActionsFetchWatch,
    initNotificationsConnectionWatch,
    deleteNotificationsFetchWatch,
} from './notifications/sagas';
import { getOrdersGridFetchWatch } from './ordersGrid/sagas';
import {
    getOrderDetailFetchWatch,
    getOrderDetailProductsFetchWatch,
    getOrderDetailFilesFetchWatch,
    getOrderDetailProductsFilesFetchWatch,
    getOrderDetailChangelogFetchWatch,
    getOrderDetailExpeditionPackagesFetchWatch,
    getOrderDetailTransportHistoryFetchWatch,
    getOrderDetailTransportsFetchWatch,
    getOrderDetailClaimsReturnsFetchWatch,
    createOrderDetailFetchWatch,
    updateOrderDetailFetchWatch,
    patchOrderDetailFetchWatch,
    createInvoiceOrderDetailFetchWatch,
    editOrderDetailEshopNoteFetchWatch, getOrderPalletsFetchWatch, getPalletTypesFetchWatch
} from './orderDetail/sagas';
import * as ordersImport from './ordersImport/sagas';
import {
    getProductsListFetchWatch,
    activateProductsFetchWatch,
    deactivateProductsFetchWatch,
    syncEansToDcixFetchWatch,
    syncProductsToDcixFetchWatch,
} from './productsList/sagas';
import { getProductsGridFetchWatch } from './productsGrid/sagas';
import {
    getProductDetailFetchWatch,
    getProductDetailChangelogFetchWatch,
    getProductDetailStockFetchWatch,
    getProductDetailOrdersFetchWatch,
    getProductDetailStockMovementsFetchWatch,
    getProductDetailProductReceivingsFetchWatch,
    getProductDetailProductOrdersGridFetchWatch,
    getProductDetailProductReturnsFetchWatch,
    createProductDetailFetchWatch,
    updateProductDetailFetchWatch,
    deleteProductFetchWatch,
    activateProductFetchWatch,
    deactivateProductFetchWatch,
} from './productDetail/sagas';
import * as productsImport from './productsImport/sagas';
import * as claimsImport from './claimsImport/sagas';
import { getProductSetsListFetchWatch } from './productSetsList/sagas';
import {
    getProductSetDetailFetchWatch,
    createProductSetDetailFetchWatch,
    updateProductSetDetailFetchWatch,
    deleteProductSetFetchWatch,
} from './productSetDetail/sagas';
import {
    getBillsOfMaterialsListFetchWatch,
    activateBillOfMaterialsFetchWatch,
    deactivateBillOfMaterialsFetchWatch,
} from './billsOfMaterialsList/sagas';
import {
    getBillOfMaterialsDetailFetchWatch,
    createBillOfMaterialsDetailFetchWatch,
    updateBillOfMaterialsDetailFetchWatch,
} from './billOfMaterialsDetail/sagas';
import { getRolesListFetchWatch } from './rolesList/sagas';
import { getRoleDetailFetchWatch, createRoleDetailFetchWatch, updateRoleDetailFetchWatch } from './roleDetail/sagas';
import { getPermissionsListFetchWatch } from './permissionsList/sagas';
import {
    getPermissionDetailFetchWatch,
    createPermissionDetailFetchWatch,
    updatePermissionDetailFetchWatch,
    deletePermissionFetchWatch,
} from './permissionDetail/sagas';
import { getUsersListFetchWatch, activateUserFetchWatch, deactivateUserFetchWatch } from './usersList/sagas';
import { getUserDetailFetchWatch, createUserDetailFetchWatch, updateUserDetailFetchWatch } from './userDetail/sagas';
import { getRolesApprovedFetchWatch } from './rolesApproved/sagas';
import { getProvidersListFetchWatch, getWaitingProvidersListFetchWatch } from './providersList/sagas';
import {
    getProviderDetailFetchWatch,
    createProviderDetailFetchWatch,
    updateProviderDetailFetchWatch,
} from './providerDetail/sagas';
import {
    getProviderConfigDetailFetchWatch,
    updateProviderConfigDetailFetchWatch,
    getProviderConfigStructureFetchWatch,
    createProviderConfigStructureFetchWatch,
    updateProviderConfigStructureFetchWatch,
} from './providerConfigDetail/sagas';
import {
    getSystemConfigDetailFetchWatch,
    updateSystemConfigDetailFetchWatch,
    getSystemConfigStructureFetchWatch,
    createSystemConfigStructureFetchWatch,
    updateSystemConfigStructureFetchWatch,
} from './systemConfigDetail/sagas';
import {
    getUserNotificationsDetailFetchWatch,
    updateUserNotificationsDetailFetchWatch,
} from './userNotificationsDetail/sagas';
import {
    getMyNotificationsFetchWatch,
    updateMyNotificationsFetchWatch,
} from './myNotifications/sagas';
import {
    getUserPermissionsDetailFetchWatch,
    updateUserPermissionsDetailFetchWatch,
} from './userPermissionsDetail/sagas';
import { getClaimsGridFetchWatch } from './claimsGrid/sagas';
import {
    getClaimDetailFetchWatch,
    createClaimDetailFetchWatch,
    updateClaimDetailFetchWatch,
    patchClaimDetailFetchWatch,
    getClaimDetailChangelogFetchWatch,
    editClaimDetailEshopNoteFetchWatch,
} from './claimDetail/sagas';
import { getReturnsGridFetchWatch } from './returnsGrid/sagas';
import {
    getReturnDetailFetchWatch,
    getReturnDetailChangelogFetchWatch,
    createReturnDetailFetchWatch,
    updateReturnDetailFetchWatch,
    patchReturnDetailFetchWatch,
    editReturnDetailEshopNoteFetchWatch,
    confirmReturnDetailFetchWatch,
} from './returnDetail/sagas';
import { synchronizeReturnsDCIXFetchWatch } from './returnsUpdate/sagas';
import { getReceivingsGridFetchWatch } from './receivingsGrid/sagas';
import { synchronizeReceivingsDCIXFetchWatch } from './receivingsUpdate/sagas';
import {
    getReceivingDetailFetchWatch,
    createReceivingDetailFetchWatch,
    updateReceivingDetailFetchWatch,
    patchReceivingDetailFetchWatch,
    getReceivingDetailChangelogFetchWatch,
    editReceivingDetailEshopNoteFetchWatch,
} from './receivingDetail/sagas';
import { getUserSettingsFetchWatch, editUserSettingsFetchWatch } from './userSettings/sagas';
import {
    patchOrderFetchWatch,
    patchMultipleOrdersFetchWatch,
    ordersChangeStatusFetchWatch,
    reorderOrderShippingFetchWatch,
    reorderMultipleOrdersShippingFetchWatch,
    synchronizeOrdersDCIXFetchWatch,
    addOrderProductsFetchWatch, removeOrderProductsFetchWatch
} from './ordersUpdate/sagas';
import { getZasilkovnaFetchWatch, getZasilkovnaCarriersListFetchWatch, getZasilkovnaCarriersFetchWatch } from './zasilkovna/sagas';
import { getCarriersListFetchWatch } from './carriersList/sagas';
import { getEgonRoutesListFetchWatch } from './egonRoutesList/sagas';
import { getEgonDeliveriesFetchWatch } from './egonDeliveries/sagas';
import {
    getEgonRouteDetailFetchWatch,
    createEgonRouteDetailFetchWatch,
    updateEgonRouteDetailFetchWatch,
    deleteEgonRouteDetailFetchWatch,
} from './egonRouteDetail/sagas';
import { getCarrierDetailFetchWatch, createCarrierDetailFetchWatch, updateCarrierDetailFetchWatch, deleteCarrierDetailFetchWatch } from './carrierDetail/sagas';
import {
    getTransportPackageTypesListFetchWatch,
    syncCatalogueTransportPackageTypesFetchWatch,
    syncTransportPackageTypesFetchWatch,
} from './transportPackageTypesList/sagas';
import {
    getTransportPackageTypeDetailFetchWatch,
    createTransportPackageTypeDetailFetchWatch,
    updateTransportPackageTypeDetailFetchWatch,
    deleteTransportPackageTypeDetailFetchWatch,
} from './transportPackageTypeDetail/sagas';
import { getWebhooksListFetchWatch } from './webhooksList/sagas';
import {
    getWebhookDetailFetchWatch,
    getWebhookDetailHistoryFetchWatch,
    createWebhookDetailFetchWatch,
    updateWebhookDetailFetchWatch,
    deleteWebhookFetchWatch,
    activateWebhookFetchWatch,
    deactivateWebhookFetchWatch,
} from './webhookDetail/sagas';
import {
    getWebhookDeliveriesGridFetchWatch,
    retryWebhookDeliveryFetchWatch,
} from './webhookDeliveriesGrid/sagas';
import { getWebhookDeliveryDetailFetchWatch } from './webhookDeliveryDetail/sagas';
import { getWebhookHistoryFetchWatch } from './webhookHistory/sagas';

import { getProviderCompaniesListFetchWatch } from './providerCompaniesList/sagas';
import {
    getProviderCompanyDetailFetchWatch,
    createProviderCompanyDetailFetchWatch,
    updateProviderCompanyDetailFetchWatch,
    deleteProviderCompanyFetchWatch,
} from './providerCompanyDetail/sagas';
import { getOrderExpeditionPackagesGridFetchWatch } from './orderExpeditionPackagesGrid/sagas';
import {
    deleteOrderExpeditionPackageDetailFetchWatch,
    getOrderExpeditionPackageDetailFetchWatch,
    updateOrderExpeditionPackageDetailFetchWatch,
} from './orderExpeditionPackageDetail/sagas';
import { getOrderMessagesOnExpeditionBoxGridFetchWatch } from './orderMessagesOnExpeditionBoxGrid/sagas';
import {
    getOrderMessagesOnExpeditionBoxDetailFetchWatch,
    createOrderMessagesOnExpeditionBoxDetailFetchWatch,
    updateOrderMessagesOnExpeditionBoxDetailFetchWatch,
    deleteOrderMessagesOnExpeditionBoxDetailFetchWatch,
} from './orderMessagesOnExpeditionBoxDetail/sagas';

import { getTransportsListFetchWatch } from './transportsList/sagas';
import {
    getTransportDetailFetchWatch,
    getTransportDetailChangelogFetchWatch,
    createTransportDetailFetchWatch,
    updateTransportDetailFetchWatch,
    getTransportPackageTypesFetchWatch,
    orderTransportShipmentFetchWatch,
    getTransportApiCallsFetchWatch,
    getTransportEventsFetchWatch,
    getTransportPickupDateFetchWatch,
} from './transportDetail/sagas';
import { getBalikovnaFetchWatch } from './balikovna/sagas';
import { getDpdPlacesFetchWatch, getDpdCountriesFetchWatch } from './dpdPlaces/sagas';
import { getTasksGridFetchWatch, confirmTaskFetchWatch } from './tasksGrid/sagas';
import { getOverviewOrdersGridFetchWatch } from './overviewOrdersGrid/sagas';
import {
    getOverviewIntervalDataFetchWatch,
    getOverviewIntervalOrdersInStatusesFetchWatch,
    getOverviewIntervalOrdersDeliveredFetchWatch,
    getOverviewIntervalTypeDataFetchWatch,
} from './overviewInterval/sagas';
import { getPplPlacesFetchWatch, getPplPlaceByAddressIdFetchWatch } from './pplPlaces/sagas';
import { getDhlServicePointsFetchWatch, getDhlServicePointByIdFetchWatch } from './dhlServicePoints/sagas';
import { updateConstantDetailFetchWatch } from './constantsCodes/sagas';
import { getProductCompletionSheetsListFetchWatch } from './productCompletionSheetsList/sagas';
import {
    getProductCompletionSheetDetailFetchWatch,
    createProductCompletionSheetDetailFetchWatch,
    updateProductCompletionSheetDetailFetchWatch,
} from './productCompletionSheetDetail/sagas';
import { getProductStockTransfersDetailFetchWatch } from './productStockTransfersDetail/sagas';
import { getSkladonMappingListFetchWatch } from './skladonMappingList/sagas';
import {
    getSkladonMappingDetailFetchWatch,
    createSkladonMappingDetailFetchWatch,
    updateSkladonMappingDetailFetchWatch,
    deleteSkladonMappingFetchWatch,
} from './skladonMappingDetail/sagas';
import { getRemindersListFetchWatch } from './remindersList/sagas';
import {
    getReminderDetailFetchWatch,
    createReminderDetailFetchWatch,
    updateReminderDetailFetchWatch,
    cancelReminderDetailFetchWatch,
    removeFromReminderAttendeesFetchWatch,
} from './reminderDetail/sagas';
import { resetPasswordFetchWatch } from './resetPassword/sagas';
import {
    getApplicationStatusMessagesListFetchWatch,
    getApplicationStatusMessagesActiveListFetchWatch,
    updateApplicationStatusMessageFetchWatch,
} from './applicationStatusMessagesList/sagas';
import {
    getApplicationStatusMessageDetailFetchWatch,
    createApplicationStatusMessageDetailFetchWatch,
    updateApplicationStatusMessageDetailFetchWatch,
} from './applicationStatusMessageDetail/sagas';
import { getEmailTemplatesListFetchWatch } from './emailTemplates/sagas';
import {
    watchActivateEmailTemplateVersion,
    watchCreateEmailTemplate,
    watchCreateEmailTemplateVersion,
    watchDeleteEmailTemplate,
    watchDeleteEmailTemplateVersion,
    watchEditEmailTemplate,
    watchEditEmailTemplateVersion,
    watchGetEmailTemplateDetail,
    watchTestEmailTemplate
} from './emailTemplateDetail/sagas';
import { getGlsSkPlacesFetchWatch, getGlsSkPlaceByAddressIdFetchWatch } from './glsskPlaces/sagas';
import { patchClaimFetchWatch, patchMultipleClaimsFetchWatch } from './claimsUpdate/sagas';
import { patchMultipleProductsFetchWatch, patchProductFetchWatch } from './productsUpdate/sagas';
import {
    patchReturnFetchWatch,
    patchMultipleReturnsFetchWatch,
} from './returnsUpdate/sagas';
import {
    patchReceivingFetchWatch,
    patchMultipleReceivingsFetchWatch,
} from './receivingsUpdate/sagas';
import {
    activateApplicationInstallDetailFetchWatch,
    deactivateApplicationInstallDetailFetchWatch,
    getApplicationInstallDetailFetchWatch,
    installApplicationInstallDetailFetchWatch
} from './applicationInstall/sagas';
import { getProviderTransferCompaniesListFetchWatch } from './providerTransferCompaniesList/sagas';
import {
    createProviderTransferCompanyDetailFetchWatch, deleteProviderTransferCompanyFetchWatch,
    getProviderTransferCompanyDetailFetchWatch, updateProviderTransferCompanyDetailFetchWatch
} from './providerTransferCompanyDetail/sagas';
import {
    getShopifyPaymentMethodsDetailFetchWatch,
    getShopifyShippingMethodsDetailFetchWatch,
    getShoptetPaymentMethodsDetailFetchWatch,
    getShoptetShippingMethodsDetailFetchWatch,
    getShoptetStatusesDetailFetchWatch,
    getWoocommercePaymentMethodsDetailFetchWatch,
    getWoocommerceShippingMethodsDetailFetchWatch,
    saveSkladonMappingWatch
} from './integration/sagas';

function* rootSaga() {
    yield all([
        loginFetchWatch(),
        forgetPasswordFetchWatch(),
        logoutFetchWatch(),
        getUserFetchWatch(),
        getProviderServiceCodesFetchWatch(),
        updateUserFetchWatch(),
        initProviderWatch(),
        getNotificationsActionsFetchWatch(),
        initNotificationsConnectionWatch(),
        deleteNotificationsFetchWatch(),
        getOrdersGridFetchWatch(),
        getOrderDetailFetchWatch(),
        getOrderDetailProductsFetchWatch(),
        getOrderDetailFilesFetchWatch(),
        getOrderDetailProductsFilesFetchWatch(),
        getOrderDetailChangelogFetchWatch(),
        getOrderDetailExpeditionPackagesFetchWatch(),
        getOrderDetailTransportHistoryFetchWatch(),
        getOrderDetailTransportsFetchWatch(),
        getOrderDetailClaimsReturnsFetchWatch(),
        createOrderDetailFetchWatch(),
        patchOrderDetailFetchWatch(),
        updateOrderDetailFetchWatch(),
        createInvoiceOrderDetailFetchWatch(),
        editOrderDetailEshopNoteFetchWatch(),
        ordersImport.addFileWatch(),
        ordersImport.validateFileImportFetchWatch(),
        ordersImport.importFilesFetchWatch(),
        getProductsListFetchWatch(),
        activateProductsFetchWatch(),
        deactivateProductsFetchWatch(),
        syncEansToDcixFetchWatch(),
        syncProductsToDcixFetchWatch(),
        getProductsGridFetchWatch(),
        getProductDetailFetchWatch(),
        getProductDetailChangelogFetchWatch(),
        getProductDetailStockFetchWatch(),
        getProductDetailOrdersFetchWatch(),
        getProductDetailStockMovementsFetchWatch(),
        getProductDetailProductReceivingsFetchWatch(),
        getProductDetailProductOrdersGridFetchWatch(),
        getProductDetailProductReturnsFetchWatch(),
        createProductDetailFetchWatch(),
        updateProductDetailFetchWatch(),
        deleteProductFetchWatch(),
        activateProductFetchWatch(),
        deactivateProductFetchWatch(),
        productsImport.addFileWatch(),
        productsImport.validateFileImportFetchWatch(),
        productsImport.importFileImportFetchWatch(),
        claimsImport.addFileWatch(),
        claimsImport.validateFileImportFetchWatch(),
        claimsImport.importClaimsFetchWatch(),
        getProductSetsListFetchWatch(),
        getProductSetDetailFetchWatch(),
        createProductSetDetailFetchWatch(),
        updateProductSetDetailFetchWatch(),
        deleteProductSetFetchWatch(),
        getBillsOfMaterialsListFetchWatch(),
        activateBillOfMaterialsFetchWatch(),
        deactivateBillOfMaterialsFetchWatch(),
        getBillOfMaterialsDetailFetchWatch(),
        createBillOfMaterialsDetailFetchWatch(),
        updateBillOfMaterialsDetailFetchWatch(),
        getRolesListFetchWatch(),
        getRoleDetailFetchWatch(),
        createRoleDetailFetchWatch(),
        updateRoleDetailFetchWatch(),
        getPermissionsListFetchWatch(),
        getPermissionDetailFetchWatch(),
        createPermissionDetailFetchWatch(),
        updatePermissionDetailFetchWatch(),
        deletePermissionFetchWatch(),
        getUsersListFetchWatch(),
        activateUserFetchWatch(),
        deactivateUserFetchWatch(),
        getUserDetailFetchWatch(),
        createUserDetailFetchWatch(),
        updateUserDetailFetchWatch(),
        getRolesApprovedFetchWatch(),
        getProvidersListFetchWatch(),
        getWaitingProvidersListFetchWatch(),
        getProviderDetailFetchWatch(),
        createProviderDetailFetchWatch(),
        updateProviderDetailFetchWatch(),
        getProviderConfigDetailFetchWatch(),
        updateProviderConfigDetailFetchWatch(),
        getProviderConfigStructureFetchWatch(),
        createProviderConfigStructureFetchWatch(),
        updateProviderConfigStructureFetchWatch(),
        getSystemConfigDetailFetchWatch(),
        updateSystemConfigDetailFetchWatch(),
        getSystemConfigStructureFetchWatch(),
        createSystemConfigStructureFetchWatch(),
        updateSystemConfigStructureFetchWatch(),
        getUserNotificationsDetailFetchWatch(),
        updateUserNotificationsDetailFetchWatch(),
        getMyNotificationsFetchWatch(),
        updateMyNotificationsFetchWatch(),
        getUserPermissionsDetailFetchWatch(),
        updateUserPermissionsDetailFetchWatch(),
        getClaimsGridFetchWatch(),
        getClaimDetailFetchWatch(),
        createClaimDetailFetchWatch(),
        updateClaimDetailFetchWatch(),
        patchClaimDetailFetchWatch(),
        getClaimDetailChangelogFetchWatch(),
        editClaimDetailEshopNoteFetchWatch(),
        getReturnsGridFetchWatch(),
        getReturnDetailFetchWatch(),
        getReturnDetailChangelogFetchWatch(),
        createReturnDetailFetchWatch(),
        updateReturnDetailFetchWatch(),
        patchReturnDetailFetchWatch(),
        editReturnDetailEshopNoteFetchWatch(),
        confirmReturnDetailFetchWatch(),
        synchronizeReturnsDCIXFetchWatch(),
        patchReturnFetchWatch(),
        patchMultipleReturnsFetchWatch(),
        getReceivingsGridFetchWatch(),
        synchronizeReceivingsDCIXFetchWatch(),
        getReceivingDetailFetchWatch(),
        createReceivingDetailFetchWatch(),
        updateReceivingDetailFetchWatch(),
        patchReceivingDetailFetchWatch(),
        getReceivingDetailChangelogFetchWatch(),
        editReceivingDetailEshopNoteFetchWatch(),
        patchReceivingFetchWatch(),
        patchMultipleReceivingsFetchWatch(),
        getUserSettingsFetchWatch(),
        editUserSettingsFetchWatch(),
        patchOrderFetchWatch(),
        patchMultipleOrdersFetchWatch(),
        ordersChangeStatusFetchWatch(),
        reorderOrderShippingFetchWatch(),
        reorderMultipleOrdersShippingFetchWatch(),
        synchronizeOrdersDCIXFetchWatch(),
        getZasilkovnaFetchWatch(),
        getZasilkovnaCarriersListFetchWatch(),
        getZasilkovnaCarriersFetchWatch(),
        getCarriersListFetchWatch(),
        getCarrierDetailFetchWatch(),
        createCarrierDetailFetchWatch(),
        updateCarrierDetailFetchWatch(),
        deleteCarrierDetailFetchWatch(),
        getEgonRoutesListFetchWatch(),
        getEgonDeliveriesFetchWatch(),
        getEgonRouteDetailFetchWatch(),
        createEgonRouteDetailFetchWatch(),
        updateEgonRouteDetailFetchWatch(),
        deleteEgonRouteDetailFetchWatch(),
        getTransportPackageTypesListFetchWatch(),
        syncTransportPackageTypesFetchWatch(),
        syncCatalogueTransportPackageTypesFetchWatch(),
        getTransportPackageTypeDetailFetchWatch(),
        createTransportPackageTypeDetailFetchWatch(),
        updateTransportPackageTypeDetailFetchWatch(),
        deleteTransportPackageTypeDetailFetchWatch(),

        getProviderCompaniesListFetchWatch(),
        getProviderCompanyDetailFetchWatch(),
        createProviderCompanyDetailFetchWatch(),
        updateProviderCompanyDetailFetchWatch(),
        deleteProviderCompanyFetchWatch(),
        getProviderTransferCompaniesListFetchWatch(),
        getProviderTransferCompanyDetailFetchWatch(),
        createProviderTransferCompanyDetailFetchWatch(),
        updateProviderTransferCompanyDetailFetchWatch(),
        deleteProviderTransferCompanyFetchWatch(),
        getOrderExpeditionPackagesGridFetchWatch(),
        getOrderExpeditionPackageDetailFetchWatch(),
        updateOrderExpeditionPackageDetailFetchWatch(),
        deleteOrderExpeditionPackageDetailFetchWatch(),
        getOrderMessagesOnExpeditionBoxGridFetchWatch(),
        getOrderMessagesOnExpeditionBoxDetailFetchWatch(),
        createOrderMessagesOnExpeditionBoxDetailFetchWatch(),
        updateOrderMessagesOnExpeditionBoxDetailFetchWatch(),
        deleteOrderMessagesOnExpeditionBoxDetailFetchWatch(),
        getTransportsListFetchWatch(),
        getTransportDetailFetchWatch(),
        getTransportDetailChangelogFetchWatch(),
        createTransportDetailFetchWatch(),
        updateTransportDetailFetchWatch(),
        getTransportPackageTypesFetchWatch(),
        orderTransportShipmentFetchWatch(),
        getTransportApiCallsFetchWatch(),
        getTransportEventsFetchWatch(),
        getTransportPickupDateFetchWatch(),
        getBalikovnaFetchWatch(),
        getDpdPlacesFetchWatch(),
        getDpdCountriesFetchWatch(),
        getTasksGridFetchWatch(),
        confirmTaskFetchWatch(),
        getOverviewOrdersGridFetchWatch(),
        getOverviewIntervalDataFetchWatch(),
        getOverviewIntervalTypeDataFetchWatch(),
        getOverviewIntervalOrdersInStatusesFetchWatch(),
        getOverviewIntervalOrdersDeliveredFetchWatch(),
        getPplPlacesFetchWatch(),
        getPplPlaceByAddressIdFetchWatch(),
        getDhlServicePointsFetchWatch(),
        getDhlServicePointByIdFetchWatch(),
        getGlsSkPlacesFetchWatch(),
        getGlsSkPlaceByAddressIdFetchWatch(),
        updateConstantDetailFetchWatch(),
        getProductCompletionSheetsListFetchWatch(),
        getProductCompletionSheetDetailFetchWatch(),
        createProductCompletionSheetDetailFetchWatch(),
        updateProductCompletionSheetDetailFetchWatch(),
        getProductStockTransfersDetailFetchWatch(),
        getSkladonMappingListFetchWatch(),
        getSkladonMappingDetailFetchWatch(),
        createSkladonMappingDetailFetchWatch(),
        updateSkladonMappingDetailFetchWatch(),
        deleteSkladonMappingFetchWatch(),
        getRemindersListFetchWatch(),
        getReminderDetailFetchWatch(),
        createReminderDetailFetchWatch(),
        updateReminderDetailFetchWatch(),
        cancelReminderDetailFetchWatch(),
        removeFromReminderAttendeesFetchWatch(),
        resetPasswordFetchWatch(),
        getApplicationStatusMessagesListFetchWatch(),
        getApplicationStatusMessagesActiveListFetchWatch(),
        updateApplicationStatusMessageFetchWatch(),
        getApplicationStatusMessageDetailFetchWatch(),
        createApplicationStatusMessageDetailFetchWatch(),
        updateApplicationStatusMessageDetailFetchWatch(),
        getEmailTemplatesListFetchWatch(),
        watchGetEmailTemplateDetail(),
        watchCreateEmailTemplate(),
        watchEditEmailTemplate(),
        watchCreateEmailTemplateVersion(),
        watchEditEmailTemplateVersion(),
        watchDeleteEmailTemplate(),
        watchDeleteEmailTemplateVersion(),
        watchActivateEmailTemplateVersion(),
        watchTestEmailTemplate(),
        patchClaimFetchWatch(),
        patchMultipleProductsFetchWatch(),
        patchProductFetchWatch(),
        patchMultipleClaimsFetchWatch(),
        addOrderProductsFetchWatch(),
        removeOrderProductsFetchWatch(),
        getApplicationInstallDetailFetchWatch(),
        installApplicationInstallDetailFetchWatch(),
        activateApplicationInstallDetailFetchWatch(),
        deactivateApplicationInstallDetailFetchWatch(),
        getShoptetStatusesDetailFetchWatch(),
        getShoptetShippingMethodsDetailFetchWatch(),
        getShoptetPaymentMethodsDetailFetchWatch(),
        saveSkladonMappingWatch(),
        getOrderPalletsFetchWatch(),
        getPalletTypesFetchWatch(),
        getShopifyPaymentMethodsDetailFetchWatch(),
        getShopifyShippingMethodsDetailFetchWatch(),
        getWoocommercePaymentMethodsDetailFetchWatch(),
        getWoocommerceShippingMethodsDetailFetchWatch(),
        getWebhooksListFetchWatch(),
        getWebhookDetailFetchWatch(),
        getWebhookDetailHistoryFetchWatch(),
        createWebhookDetailFetchWatch(),
        updateWebhookDetailFetchWatch(),
        deleteWebhookFetchWatch(),
        activateWebhookFetchWatch(),
        deactivateWebhookFetchWatch(),
        getWebhookDeliveriesGridFetchWatch(),
        retryWebhookDeliveryFetchWatch(),
        getWebhookDeliveryDetailFetchWatch(),
        getWebhookHistoryFetchWatch(),
    ]);
}

export default rootSaga;
